import React from 'react';
import RegisterForm from '../../components/auth/RegisterForm';
const Register = () => {
  return <div className="w-full py-16 bg-gray-100" data-id="element-605">
      <div className="container mx-auto px-4" data-id="element-606">
        <RegisterForm data-id="element-607" />
      </div>
    </div>;
};
export default Register;